function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z",
  fill: "#2DB35C"
});

var SvgIconCorrectActive = function SvgIconCorrectActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDIwQzQuNDc3IDIwIDAgMTUuNTIzIDAgMTBDMCA0LjQ3NyA0LjQ3NyAwIDEwIDBDMTUuNTIzIDAgMjAgNC40NzcgMjAgMTBDMjAgMTUuNTIzIDE1LjUyMyAyMCAxMCAyMFoiIGZpbGw9IiMyREIzNUMiLz4KPC9zdmc+Cgo=";
export { SvgIconCorrectActive as ReactComponent };